module.exports = __webpack_public_path__ + "img/modelpicker.b1b94888.jpg";